<template>
  <div>
    <Header :breadcrumsfirst="breadcrumsfirst" :breadcrumslast="breadcrumslast" />
    <Subheader :title="`${assetId ? 'Edit' : 'Add New'} Asset`" />

    <div class="container">
      <div class="row py-3">
        <div class="col-md-3">
          <div class="form-group">
            <label for="assetTypeId" class="custom-label">ID</label>
            <input id="assetTypeId" type="text" class="form-control shadow-none custom-input"
              placeholder="This is autogenerated" readonly v-model="saveData.id">
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label for="assetTypeName" class="custom-label">Title</label>
            <input id="assetTypeName" class="form-control shadow-none custom-input" placeholder="Enter text"
              v-model="saveData.title">
          </div>
        </div>
        <div class="col-md-3 mb-3">
          <div class="form-group">
            <label class="custom-label">Parent Asset</label>
            <select class="form-select form-control shadow-none custom-input custom-dropdown" id="autoSizingSelect"
              v-model="saveData.parentassetid">
              <option value="" disabled selected>Select Option</option>
               <option :value="''"  selected>None</option>
              <option v-for="asset in assets" :key="asset.uuid" :value="asset.uuid">{{ asset.name }}</option>
            </select>
          </div>
        </div>
        <div class="row align-items-center">
          <div class="col-md-3 mb-3">
            <div class="form-group">
              <label class="custom-label">Asset Type</label>
              <div class="custom-multiple-dropdown-wrapper">
                <select class="form-select form-control shadow-none custom-input custom-dropdown" id="autoSizingSelect"
                  v-model="saveData.assettypeid">
                  <option value="" disabled selected>Select Option</option> <!-- Placeholder option -->
                  <option v-for="assetType in assetTypes" :key="assetType.uuid" :value="assetType.uuid">{{
                    assetType.name }}</option>
                </select>
                <button @click="updateSelectedAssetTypes(saveData.assettypeid)"
                  class="multiple-dropdown-add-button">+</button>
              </div>
            </div>
          </div>

          <div class="col-md-9 mb-3 align-self-end custom-input">
            <div v-if="selectedAssetTypes.length > 0" class="custom-multiple-dropdown-container">
              <div v-for="(assetType, index) in selectedAssetTypes" :key="index">
                <span class="custom-multiple-dropdown">{{ assetType }}
                  <button class="multiple-dropdown-delete-icon" @click="removeSelectedAssetType(index)">
                    <dropdownDeleteIcon />
                  </button>
                </span>
              </div>
            </div>
          </div>
          <small v-if="selectedAssetTypes.length === 0" class="text-danger"
            style="margin-top: -10px; font-size: 11px;">Select asset type</small>
        </div>


        <div class="col-md-12 mb-3">
          <div class="form-group">
            <label for="assetTypeDesc" class="custom-label">Description</label>
            <input id="assetTypeDesc" class="form-control shadow-none custom-input" placeholder="Enter text"
              v-model="saveData.description">
          </div>
        </div>
        <div class="col-md-12 mb-3">
          <div class="form-group">
            <label for="assetTypeNote" class="custom-label">Notes</label>
            <textarea id="assetTypeNote" class="form-control shadow-none custom-input" placeholder="Enter text" rows="4"
              v-model="saveData.note"></textarea>
          </div>
        </div>
        <div class="col-md-3" v-if="this.assetId">
          <div class="form-group">
            <button type="button" class="btn btn-danger btn-sm delete-button" data-bs-toggle="modal"
              data-bs-target="#exampleModal">Delete</button>
          </div>
        </div>
        <deleteModal v-if="this.assetId" :deleteRecord="deleteRecord" />
        <div class="col-md-8 d-flex justify-content-end" v-if="this.assetId">

          <div class="form-group">
            <button type="button" class="btn btn-secondary btn-sm cancel-button" @click="cancelButton()">Cancel</button>
          </div>
        </div>
        <div class="col-md-11 d-flex justify-content-end" v-else>
          <div class="form-group">
            <button type="button" class="btn btn-secondary btn-sm cancel-button" @click="cancelButton()">Cancel</button>
          </div>
        </div>
        <div class="col-md-1 d-flex justify-content-start">
          <div class="form-group">
            <button type="submit" class="btn btn-primary btn-sm submit-button" :disabled="isSubmitDisabled"
              @click="addAssetData()">Submit</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from '@/components/Header.vue';
import Subheader from '@/components/Subheader.vue';
import deleteModal from '@/components/delete-modal.vue';
import { addAsset, ddAssetType, ddAsset, getByIdAsset, updateAsset } from '@/http/iot-asset/asset.http';
import dropdownDeleteIcon from '@/components/dropdown-delete-icon.vue';
export default {
  name: 'asset-form',
  components: {
    Header,
    Subheader,
    deleteModal,
    dropdownDeleteIcon
  },
  data() {
    return {
      breadcrumsfirst: "IoT Assets",
      breadcrumslast: "Asset",
      saveData: {
        assettypeid: '',
        parentassetid: ''
      },
      assetTypes: [],
      assets: [],
      selectedAssetTypes: [],
      assetId: this.$route.params.id,
    }
  },
  mounted() {
    this.getAssetTypeDropdownData()
      .then(() => {
        return this.getDetailData();
      })
      .then(() => {
        this.getParentAssetDropdownData();
      })
      .catch(error => {
        console.error('Error mounting component:', error);
      });
  },
  computed: {
    isSubmitDisabled() {
      return this.selectedAssetTypes.length === 0;
    }
  },

  methods: {
    addAssetData() {
      const selectedAssetTypeIds = this.selectedAssetTypes.map(assetTypeName => {
        const assetType = this.assetTypes.find(assetType => assetType.name === assetTypeName);
        return assetType ? assetType.uuid : null;
      }).filter(Boolean).join(',');
      // Assign selected asset type IDs to saveData
      this.saveData.assettypeid = selectedAssetTypeIds;

      if (this.assetId) {
        const payload = {
          uuid: this.$route.params.id,
        };

        updateAsset({ ...payload, ...this.saveData }).then(() => {
          this.saveData.updatedon = new Date().toISOString();
          this.$router.push("/iotassets/asset");
        }).catch((error) => {
          this.error = error.message;
        });
      } else {
        addAsset(this.saveData)
          .then(() => {
            this.$router.push("/iotassets/asset");
          })
          .catch(error => {
            console.error('Error adding asset:', error);
          });
      }
    },
    updateSelectedAssetTypes(assetTypeId) {
      const assetType = this.assetTypes.find(assetType => assetType.uuid === assetTypeId);
      if (assetType && !this.selectedAssetTypes.includes(assetType.name)) {
        this.selectedAssetTypes.push(assetType.name);
      }
    },
    removeSelectedAssetType(index) {
      this.selectedAssetTypes.splice(index, 1);
    },
    // getAssetTypeDropdownData(){
    //     // Fetch asset types
    // ddAssetType()
    //             .then(assetTypesResponse => {
    //                 this.assetTypes = assetTypesResponse;
    //                 // Set the default value for asset type dropdown based on fetched asset type ID

    //             })
    //             .catch(error => {
    //                 console.error('Error fetching asset types:', error);
    //             });
    // },
    async getAssetTypeDropdownData() {
      try {
        this.assetTypes = await ddAssetType();
      } catch (error) {
        console.error('Error fetching asset types:', error);
        throw error;
      }
    },
    async getDetailData() {
      try {
        if (this.assetId) {
          const response = await getByIdAsset(this.assetId);
          this.saveData = response;
          this.saveData.parentassetid = response.parentassetid;

          if (Array.isArray(response.assettypeid) && response.assettypeid.length > 0) {
            this.selectedAssetTypes = response.assettypeid.map(assetTypeId => {
              const assetType = this.assetTypes.find(type => type.uuid === assetTypeId);
              return assetType ? assetType.name : '';
            });
            this.saveData.assettypeid = '';
          } else {
            this.saveData.assettypeid = '';
          }
        }
      } catch (error) {
        console.error('Error fetching asset details:', error);
        throw error;
      }
    },


    //   getDetailData(){
    //     if (this.assetId) {
    //   // Fetch asset details by ID
    //   getByIdAsset(this.assetId)
    //     .then(response => {
    //       // Update saveData with the fetched data
    //       this.saveData = response;
    //       // Set the parentassetid to match the fetched data
    //       this.saveData.parentassetid = response.parentassetid;

    //       // Check if assettypeid is an array and not empty
    //       if (Array.isArray(response.assettypeid) && response.assettypeid.length > 0) {
    //         // Map asset type IDs to their names and populate selectedAssetTypes array
    //         this.selectedAssetTypes = response.assettypeid.map(assetTypeId => {
    //           const assetType = this.assetTypes.find(type => type.uuid === assetTypeId);
    //           return assetType ? assetType.name : '';
    //         });
    //         // Set the selected asset type ID in the saveData
    //         this.saveData.assettypeid = '';
    //         // this.saveData.assettypeid = response.assettypeid[0]; // Assuming only one asset type is selected
    //       } else {
    //         this.saveData.assettypeid = '';
    //         // If no asset type is selected, set assettypeid to an empty string
    //         // this.saveData.assettypeid = '';
    //       }
    //     })
    //     .catch(error => {
    //       console.error('Error fetching asset details:', error);
    //     });
    // } else {
    //   // If there's no asset ID (i.e., it's a new asset), set assettypeid to an empty string
    //   this.saveData.assettypeid = '';
    // }
    //   },

    getParentAssetDropdownData() {
      // Fetch assets
      ddAsset()
        .then(response => {
          this.assets = response;
          // Set default value for parentassetid
          if (this.assets.length > 0) {
            // Check if assetId is set and update parentassetid accordingly
            if (this.assetId) {
              const index = this.assets.findIndex(asset => asset.uuid === this.saveData.parentassetid);
              if (index !== -1) {
                this.saveData.parentassetid = this.assets[index].uuid;
              }
            } 
            else {
              this.saveData.parentassetid = '';
            }
          }
        })
        .catch(error => {
          console.error('Error fetching assets:', error);
        });
    },

    cancelButton() {
      this.$router.push("/iotassets/asset")
    },
    deleteRecord() {
      this.saveData.issoftdelete = 1;
      const payload = {
        issoftdelete: this.saveData.issoftdelete ? 1 : 0,
        uuid: this.$route.params.id,
      };
      const selectedAssetTypeIds = this.selectedAssetTypes.map(assetTypeName => {
        const assetType = this.assetTypes.find(assetType => assetType.name === assetTypeName);
        return assetType ? assetType.uuid : null;
      }).filter(Boolean).join(',');
      // Assign selected asset type IDs to saveData
      this.saveData.assettypeid = selectedAssetTypeIds;
      updateAsset({ ...payload, ...this.saveData }).then(() => {
        this.saveData.updatedon = new Date().toISOString();
        this.$router.push("/iotassets/asset");
      }).catch((error) => {
        this.error = error.message;
      });

    },
  }
}
</script>

<style scoped></style>